<template>
  
  <div id="app_content" class="admin admin-customers">

    <h4 class="mt-0 title is-4 uc">Gestione clienti</h4>

    <section class="header">
      
      <!-- <button class="belt-btn-small" @click="register = true">registra nuovo utente</button> -->

      <!-- <button class="belt-btn-small" @click="massAssignment = true">assegnazione massiva delle credenziali</button> -->

    </section>

    <section class="customers admin-section" :class="{v_loading: loading}">

      <div class="filter-customers">

        <label class="w-100 block">Filtra clienti</label>
        <input type="text" v-model="query" placeholder="Inserisci la ragione sociale o il codice cliente" name="query">

      </div>

      <ul v-if="filteredCustomers && filteredCustomers.length > 0" class="customers-list">

        <li v-for="customer in filteredCustomers" class="single-customer" :key="customer.id">

          <single-customer :customer="customer"/>

        </li>

      </ul>

      <p v-else class="empty">Nessun cliente trovato...</p>

    </section>

    <register-user v-if="register"/>
    <mass-assignment v-if="massAssignment"/>

  </div>

</template>

<script>
import singleCustomer from './single-customer'
import registerUser from './register-user'
import MassAssignment from './mass-assignment'
export default{
  
  components: {singleCustomer, registerUser, MassAssignment},

  data: function(){

    return {
      loading: false,
      customers: [],
      register: false,
      query: '',
      massAssignment: false,
      test_etichetta: "Test etichetta"
    }

  },

  computed: {

    filteredCustomers: function(){

      if( !this.query || this.query == '' )
        return this.customers

      return _.filter( this.customers, value => {

        return (value.ragione_sociale.toLowerCase().indexOf( this.query ) > -1) ||
               (value.cod_cli_for.toString().indexOf( this.query ) > -1);

      });

    }

  },

  methods: {

    loadCustomers: function(){

      var vue = this;
      vue.loading = true;

      axios({
        method: "get",
        url: window.location.origin +  '/data/get-customers'
      })
      .then(res => {

        if( res.data.utenti ) vue.customers = res.data.utenti; 

      })
      .catch(err => {

        console.log( err );
        
      })
      .then(() =>{
        vue.loading = false;
      })

    }

  },

  mounted: function(){

    this.loadCustomers();

  }

}
</script>

<style scoped>
section.customers{
  margin-top: 2em;
}
ul.customers-list{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
ul.customers-list li{
  padding: 2em;
  border-bottom: 1px solid black;
}
input[name="query"]{
  padding: 5px 10px;
  border: 1px solid gray;
  width: 100%;
  max-width: 500px;
}
</style>
